import styles from './Timeline.module.sass'
import cn from "classnames";
import Image from "next/image";
import {useGameContext} from "@/context/GameContext";
const Timeline = ({className, ...props}) => {

	const {gameTimelineRef, isScrollingRef} = useGameContext()
	const handleTimelineClick = (e) => {
		let labelTime = undefined;

		switch (e.currentTarget.id) {
			case 'tl_light':
				labelTime = gameTimelineRef.current.labels['start']
				break;
			case 'tl_compass':
				labelTime = gameTimelineRef.current.labels['take_compass']
				break;
			case 'tl_parchment':
				labelTime = gameTimelineRef.current.labels['take_parchment']
				break;
			case 'tl_sword':
				labelTime = gameTimelineRef.current.labels['take_sword']
				break;
			case 'tl_chest':
				labelTime = gameTimelineRef.current.labels['take_chest']
				break;
			case 'tl_lawyer':
				labelTime = gameTimelineRef.current.labels['game-animation-end']
				break;
		}

		if(labelTime === undefined) return
		const scrollToPosition = Math.ceil((labelTime / gameTimelineRef.current.duration()) * (gameTimelineRef.current.scrollTrigger.end))

		isScrollingRef.current = true
		window.lenis.scrollTo(scrollToPosition, {
			lock: true,
			force: true,
			duration: 2,
			onComplete: () => {
				isScrollingRef.current = false
			}
		})
	}

	return (
		<div className={cn(styles.timeline, className)} {...props}>
			<div className={cn(styles.inner_line, 'Timeline__progression')}></div>

			{/*Elements*/}
			<div className={cn(styles.elements, 'custom_pointer')}>
				<Image className={cn(styles.icon, styles.sparkles, 'timeline_sparkles_icon', 'basic_pointer')} src={'/images/Game/Glow/sparkles.gif'} alt={"Sparkles"} width={64} height={64}/>
				<Image className={cn(styles.icon, styles.light_bubble)} id={'tl_light'} src={'/images/Game/Timeline/light_bubble.gif'} alt={"Light Bubble"} width={29} height={20} onClick={handleTimelineClick}/>
				<Image className={cn(styles.icon, styles.compass, 'timeline_compass_icon')} id={'tl_compass'} src={'/images/Game/Timeline/compass--stroke.png'} alt={"Compass"} width={145} height={144} onClick={handleTimelineClick}/>
				<Image className={cn(styles.icon, styles.parchment, 'timeline_parchment_icon')} id={'tl_parchment'} src={'/images/Game/Timeline/parchment--stroke.png'} alt={"Parchment"} width={145} height={144} onClick={handleTimelineClick}/>
				<Image className={cn(styles.icon, styles.sword, 'timeline_sword_icon')} id={'tl_sword'} src={'/images/Game/Timeline/sword--stroke.png'} alt={"Sword"} width={145} height={144} onClick={handleTimelineClick}/>
				<Image className={cn(styles.icon, styles.chest, 'timeline_chest_icon')} id={'tl_chest'} src={'/images/Game/Timeline/chest--stroke.png'} alt={"Chest"} width={145} height={144} onClick={handleTimelineClick}/>
				<Image className={cn(styles.icon, styles.lawyer, 'timeline_lawyer_icon')} id={'tl_lawyer'} src={'/images/Game/Timeline/lawyer_head.png'} alt={"Lawyer"} width={145} height={144} onClick={handleTimelineClick}/>
			</div>

			{/*Mini Sacha*/}
			<div className={styles.mini_sacha}>
				<Image className={styles.mini_sacha__img} src={'/images/Game/Timeline/mini_sacha.png'} alt="Sacha" width={100} height={100}/>
			</div>
		</div>
	)
}
export default Timeline
